/* eslint-disable @tencent/i18next/no-literal-string */
import React from 'react';
import {
    ELEMENT_H_ALIGN_CENTER,
    ELEMENT_H_ALIGN_DIS,
    ELEMENT_H_ALIGN_LEFT,
    ELEMENT_H_ALIGN_RIGHT,
    ELEMENT_H_ALIGN_VCENTER,
    ELEMENT_V_ALIGN_BOTTOM,
    ELEMENT_V_ALIGN_DIS,
    ELEMENT_V_ALIGN_TOP,
    INDENT_INCREASE_ICON,
    INDENT_REDUCE_ICON,
    TOOLBAR_ADDGROUP,
    TOOLBAR_ADDON,
    TOOLBAR_ADDON_TOOL,
    TOOLBAR_AI_WRITTING,
    TOOLBAR_ANIM,
    TOOLBAR_ARRANGE,
    TOOLBAR_BACKCOLOR,
    TOOLBAR_BOLD,
    TOOLBAR_BORDER,
    TOOLBAR_BOX,
    TOOLBAR_BOX_1,
    TOOLBAR_BOX_10,
    TOOLBAR_BOX_2,
    TOOLBAR_BOX_3,
    TOOLBAR_BOX_4,
    TOOLBAR_BOX_5,
    TOOLBAR_BOX_6,
    TOOLBAR_BOX_7,
    TOOLBAR_BOX_8,
    TOOLBAR_BOX_9,
    TOOLBAR_CLEARFORMAT,
    TOOLBAR_CLIP,
    TOOLBAR_DELETELINE,
    TOOLBAR_DIGITNUMBER,
    TOOLBAR_DROPDOWN,
    TOOLBAR_EFFECT,
    TOOLBAR_FILLCOLOR,
    TOOLBAR_FONT_SIZE_DECREASE,
    TOOLBAR_FONT_SIZE_INCREASE,
    TOOLBAR_FORECOLOR,
    TOOLBAR_FORM,
    TOOLBAR_FORMAT,
    TOOLBAR_GLOW_ICON,
    TOOLBAR_H_ALIGN_CENTER,
    TOOLBAR_H_ALIGN_DISTRIBUTE,
    TOOLBAR_H_ALIGN_JUSTIFY,
    TOOLBAR_H_ALIGN_LEFT,
    TOOLBAR_H_ALIGN_RIGHT,
    TOOLBAR_IMAGE_TRANS,
    TOOLBAR_INSERT_DOC,
    TOOLBAR_ITALIC,
    TOOLBAR_ITEMNUMBER,
    TOOLBAR_LATEX,
    TOOLBAR_LINK,
    TOOLBAR_LISTMORE,
    TOOLBAR_MERGECELL,
    TOOLBAR_MOVEBOTTOM,
    TOOLBAR_MOVEDOWN,
    TOOLBAR_MOVETOP,
    TOOLBAR_MOVEUP,
    TOOLBAR_PAGE_SEETING_ICON,
    TOOLBAR_PICTURE,
    TOOLBAR_QUICK_TOOL_ICON,
    TOOLBAR_REDO,
    TOOLBAR_REFLECTION_ICON,
    TOOLBAR_REMOVEGROUP,
    TOOLBAR_ROWSPACING,
    TOOLBAR_SEARCH_REPLACE,
    TOOLBAR_SELECT_WINDOW,
    TOOLBAR_SHADOW_ICON,
    TOOLBAR_SHAPE,
    TOOLBAR_SLIDEBACKGROUND,
    TOOLBAR_SLIDESIZE_CUSTOM,
    TOOLBAR_SLIDESIZE_STANDARD,
    TOOLBAR_SLIDESIZE_WIDE,
    TOOLBAR_SOFTEDGE_ICON,
    TOOLBAR_SUBSCRIPT,
    TOOLBAR_SUPERSCRIPT,
    TOOLBAR_TEXT,
    TOOLBAR_UNDERLINE,
    TOOLBAR_UNDO,
    TOOLBAR_UPLOAD_FILE,
    TOOLBAR_V_ALIGN_BOTTOM,
    TOOLBAR_V_ALIGN_CENTER,
    TOOLBAR_V_ALIGN_TOP,
} from '../../img/pageIndex';
import TOOLBAR_PLUGIN from '@tencent/docs-design-resources/pc/png@3x/toolbar_plugin@3x.png';
import {
    CharacterTypes,
    OfficeNumberType,
} from '@src/slide/domain/ui-model/element-modeles/property/text/constants/character-type';

import { ActionType, ChildActionType } from './common-action-type';
import i18n from '@i18next/i18n';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import _get from 'lodash/get';
import IntelligentToolDescriptionCard from '@com-pc/intelligent-tool-description-card';
import UploadFileTooltip from '@src/framework/frame/components/option-menu/upload-file-tooltip';
import { ToolbarType } from '@src/js/constant';
import { deepCopy } from '@src/slide/infrastructure/module/independent/object-operation';
import BulletsDropdownItem from '@src/framework/workbench/common/components/bullets-dropdown-item';
import BulletSymbol from '@framework/workbench/ui/item-number/components/bullet-symbol';
import {
    getConvertAutoNumCharacterText,
} from '@src/slide/domain/ui-model/element-modeles/property/text/utils/character-utils/auto-num-type';
import { SHAPE_IMAGE_FILL, SHAPE_IMAGE_TILE_FILL } from '@src/slide/domain/ui-model/element-modeles/constant';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IMenuItem } from '@src/slide/application/service/menu-manager/menu-items/menu-items.interface';
import {
    AlignType,
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';
import { getFontFamilyConfigData, getAllLegalFontFamilyConfigData } from './font-list';
import { MOVE_DOWN_CONFIG } from '@src/framework/workbench/ui/move/move-down/config';
import { MOVE_UP_CONFIG } from '@src/framework/workbench/ui/move/move-up/config';
import { SELECT_WINDOW_CONFIG } from '@src/framework/workbench/ui/move/select-window/config';

export {  getFontFamilyConfigData, getAllLegalFontFamilyConfigData };

export const DropdownType = {
    COMMON: 'common',
    FONT: 'font',
    FONT_FAMILY: 'font_family',
    COLOR: 'color',
    GRID: 'grid',
    CROP: 'crop',
    SHAPE: 'shape',
    TOOLBAR: 'toolbar',
    TEMPLATE: 'template',
    INSERTTABLE: 'insertTable',
    CUSTOM: 'custom',
    TEXT_IMAGE: 'text_image',
    EFFECT: 'effect',
    INNER_TOOLBAR: 'inner-toolbar',
    ADDON: 'addon',
    CHART_COMPONENT: 'chart-component',
    CHART_TYPE: 'chart-type',
    AI_PICTURE: 'ai-picture',
};

export const ItemSymbolType = CharacterTypes;

// 项目符号的默认值 id
export const DEFAULT_ITEM_SYMBOL_TYPE = ItemSymbolType.ITEMSYMBOL_SMALL_CIRCLE;

export const BorderConfigType = {
    BORDER_NONE: 'border_none',
    BORDER_ALL: 'border_all',
    BORDER_OUTER: 'border_outer',
    BORDER_INNER: 'border_inner',
    BORDER_HORIZONTAL: 'border_horizontal',
    BORDER_VERTICAL: 'border_vertical',
    BORDER_TOP: 'border_top',
    BORDER_RIGHT: 'border_right',
    BORDER_BOTTOM: 'border_bottom',
    BORDER_LEFT: 'border_left',
};

export const fontSizeConfigData = [
    ['8', 'font-size-8pt'],
    ['9', 'font-size-9pt'],
    ['10', 'font-size-10pt'],
    ['10.5', 'font-size-10.5pt'],
    ['11', 'font-size-11pt'],
    ['12', 'font-size-12pt'],
    ['14', 'font-size-14pt'],
    ['16', 'font-size-16pt'],
    ['18', 'font-size-18pt'],
    ['20', 'font-size-20pt'],
    ['24', 'font-size-24pt'],
    ['28', 'font-size-28pt'],
    ['32', 'font-size-32pt'],
    ['36', 'font-size-36pt'],
    ['40', 'font-size-40pt'],
    ['44', 'font-size-44pt'],
    ['48', 'font-size-48pt'],
    ['54', 'font-size-54pt'],
    ['60', 'font-size-60pt'],
    ['66', 'font-size-66pt'],
    ['72', 'font-size-72pt'],
    ['80', 'font-size-80pt'],
    ['88', 'font-size-88pt'],
    ['96', 'font-size-96pt'],
    ['104', 'font-size-104pt'],
    ['112', 'font-size-112pt'],
    ['120', 'font-size-120pt'],
    ['128', 'font-size-128pt'],
    ['136', 'font-size-136pt'],
    ['144', 'font-size-144pt'],
    ['152', 'font-size-152pt'],
    ['160', 'font-size-160pt'],
    ['168', 'font-size-168pt'],
    ['176', 'font-size-176pt'],
    ['184', 'font-size-184pt'],
    ['192', 'font-size-192pt'],
];

export const effectDropdownData = [
    { type: ActionType.SHADOW, icon: TOOLBAR_SHADOW_ICON, content: i18n.t('阴影') },
    { type: ActionType.REFLECTION, icon: TOOLBAR_REFLECTION_ICON, content: i18n.t('映像') },
    { type: ActionType.GLOW, icon: TOOLBAR_GLOW_ICON, content: i18n.t('发光') },
    { type: ActionType.SOFTEDGE, icon: TOOLBAR_SOFTEDGE_ICON, content: i18n.t('柔化边缘') },
];

const DIVIDE = 'divide';

export const divider = {
    id: ActionType.DIVIDER,
};

export interface ToolListDropdownType {
    id?: string|number;
    showSelectedValue?: boolean;
    icon?: any;
    type?: string;
    content?: any;
    tipPlacement?: string;
    aid?: string;
    toggle?: boolean;
    tooltip?: any;
    tipMsg?: string;
    checkSelectedValue?: boolean;
    columns?: number;
    children?: ToolListDropdownType[];
    data?: ToolListDropdownType[];
}

export interface ToolListType extends IMenuItem {
    id: string;
    tipMsg?: string;
    title?: string;
    content?: string;
    icon?: any;
    aid?: string;
    showSelectedValue?: boolean;
    value?: string|boolean;
    toggle?: boolean;
    shortcut?: string;
    disabledContent?: string;
    children?: ToolListType[];
    dropdown?: ToolListDropdownType;
}

export const getFontSizeConfigData = () => {
    const datas: { id: string; content: string; }[] = [];
    // eslint-disable-next-line array-callback-return
    fontSizeConfigData.map((itemData) => {
        const [content, id] = itemData;
        datas.push({ id, content });
    });
    return datas;
};

export const getInsertTableMenuData = () => {
    const datas: null[] = [];
    for (let i = 0; i < 80; i++) {
        datas.push(null);
    }
    return datas;
};

export const getItemSymbolData = (color = undefined, customText = null, customImage = null) => [
    {
        id: ItemSymbolType.ITEMSYMBOL_NONE,
        icon: null,
        content: i18n.t('无'),
    },
    {
        id: ItemSymbolType.ITEMSYMBOL_CIRCLE,
        content: (
            <BulletsDropdownItem labels={[
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_CIRCLE} key="1"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_CIRCLE} key="2"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_CIRCLE} key="3"/>,
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: ItemSymbolType.ITEMSYMBOL_SQUARE,
        content: (
            <BulletsDropdownItem labels={[
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_SQUARE} key="1"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_SQUARE} key="2"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_SQUARE} key="3"/>,
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: ItemSymbolType.ITEMSYMBOL_RHOMBUS,
        content: (
            <BulletsDropdownItem labels={[
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_RHOMBUS} key="1"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_RHOMBUS} key="2"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_RHOMBUS} key="3"/>,
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: ItemSymbolType.ITEMSYMBOL_STAR,
        content: (
            <BulletsDropdownItem labels={[
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_STAR} key="1"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_STAR} key="2"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_STAR} key="3"/>,
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: ItemSymbolType.ITEMSYMBOL_CHECK,
        content: (
            <BulletsDropdownItem labels={[
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_CHECK} key="1"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_CHECK} key="2"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_CHECK} key="3"/>,
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: ItemSymbolType.ITEMSYMBOL_ARROW,
        content: (
            <BulletsDropdownItem labels={[
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_ARROW} key="1"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_ARROW} key="2"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_ARROW} key="3"/>,
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    getLastSymbolData(color, customText, customImage),
];

function getLastSymbolData(color, customText = null, customImage = null) {
    if (customText) {
        return {
            id: ItemSymbolType.CUSTOM_TEXT,
            content: (
                <BulletsDropdownItem
                    labels={[customText, customText, customText]} color={color}></BulletsDropdownItem>
            ),
        };
    }
    if (customImage) {
        return {
            id: ItemSymbolType.CUSTOM_IMAGE,
            content: (
                <BulletsDropdownItem
                    labels={[
                        <img src={customImage} key="1"/>,
                        <img src={customImage} key="1"/>,
                        <img src={customImage} key="1"/>,
                    ]} color={color}></BulletsDropdownItem>
            ),
        };
    }
    return {
        id: ItemSymbolType.ITEMSYMBOL_SMALL_CIRCLE,
        content: (
            <BulletsDropdownItem labels={[
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_SMALL_CIRCLE} key="1"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_SMALL_CIRCLE} key="2"/>,
                <BulletSymbol type={ItemSymbolType.ITEMSYMBOL_SMALL_CIRCLE} key="3"/>,
            ]} color={color}></BulletsDropdownItem>
        ),
    };
}

export const getDigitalNumeberData = (color = undefined, startAt = 1) => [
    {
        id: ItemSymbolType.ITEMSYMBOL_NONE,
        icon: null,
        content: i18n.t('无'),
    },
    {
        id: OfficeNumberType.arabicPeriod,
        content: (
            <BulletsDropdownItem labels={[
                getConvertAutoNumCharacterText({ type: OfficeNumberType.arabicPeriod, startAt }, 0),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.arabicPeriod, startAt }, 1),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.arabicPeriod, startAt }, 2),
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: OfficeNumberType.circleNumDbPlain,
        content: (
            <BulletsDropdownItem labels={[
                getConvertAutoNumCharacterText({ type: OfficeNumberType.circleNumDbPlain, startAt }, 0),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.circleNumDbPlain, startAt }, 1),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.circleNumDbPlain, startAt }, 2),
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: OfficeNumberType.arabicParenBoth,
        content: (
            <BulletsDropdownItem labels={[
                getConvertAutoNumCharacterText({ type: OfficeNumberType.arabicParenBoth, startAt }, 0),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.arabicParenBoth, startAt }, 1),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.arabicParenBoth, startAt }, 2),
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: OfficeNumberType.romanUcPeriod,
        content: (
            <BulletsDropdownItem labels={[
                getConvertAutoNumCharacterText({ type: OfficeNumberType.romanUcPeriod, startAt }, 0),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.romanUcPeriod, startAt }, 1),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.romanUcPeriod, startAt }, 2),
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: OfficeNumberType.alphaUcPeriod,
        content: (
            <BulletsDropdownItem labels={[
                getConvertAutoNumCharacterText({ type: OfficeNumberType.alphaUcPeriod, startAt }, 0),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.alphaUcPeriod, startAt }, 1),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.alphaUcPeriod, startAt }, 2),
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: OfficeNumberType.alphaLcPeriod,
        content: (
            <BulletsDropdownItem labels={[
                getConvertAutoNumCharacterText({ type: OfficeNumberType.alphaLcPeriod, startAt }, 0),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.alphaLcPeriod, startAt }, 1),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.alphaLcPeriod, startAt }, 2),
            ]} color={color}></BulletsDropdownItem>
        ),
    },
    {
        id: OfficeNumberType.ea1JpnChsDbPeriod,
        content: (
            <BulletsDropdownItem labels={[
                getConvertAutoNumCharacterText({ type: OfficeNumberType.ea1JpnChsDbPeriod, startAt }, 0),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.ea1JpnChsDbPeriod, startAt }, 1),
                getConvertAutoNumCharacterText({ type: OfficeNumberType.ea1JpnChsDbPeriod, startAt }, 2),
            ]} color={color}></BulletsDropdownItem>
        ),
    },
];

export const getBorderStyleData = () => [
    {
        id: BorderConfigType.BORDER_ALL,
        icon: TOOLBAR_BOX_1,
        tipMsg: i18n.t('所有边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_INNER,
        icon: TOOLBAR_BOX_2,
        tipMsg: i18n.t('内部边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_HORIZONTAL,
        icon: TOOLBAR_BOX_3,
        tipMsg: i18n.t('水平边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_VERTICAL,
        icon: TOOLBAR_BOX_4,
        tipMsg: i18n.t('垂直边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_OUTER,
        icon: TOOLBAR_BOX_5,
        tipMsg: i18n.t('外部边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_LEFT,
        icon: TOOLBAR_BOX_6,
        tipMsg: i18n.t('左侧边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_TOP,
        icon: TOOLBAR_BOX_7,
        tipMsg: i18n.t('顶部边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_RIGHT,
        icon: TOOLBAR_BOX_8,
        tipMsg: i18n.t('右侧边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_BOTTOM,
        icon: TOOLBAR_BOX_9,
        tipMsg: i18n.t('底部边框'),
        tipPlacement: 'bottom',
    },
    {
        id: BorderConfigType.BORDER_NONE,
        icon: TOOLBAR_BOX_10,
        tipMsg: i18n.t('无边框'),
        tipPlacement: 'bottom',
    },
];

export const defaultTemplates = {
    id: ActionType.ADD_SLIDE,
    content: i18n.t('添加页面'),
    dropdown: {
        type: DropdownType.TEMPLATE,
        dropIcon: TOOLBAR_DROPDOWN,
        columns: 3,
        masterList: [
            {
                themeName: i18n.t('腾讯文档默认模板'),
                layoutList: [
                    {
                        name: i18n.t('空白'),
                    },
                    {
                        name: i18n.t('仅标题'),
                    },
                    {
                        name: i18n.t('内容与标题'),
                    },
                    {
                        name: i18n.t('图片与标题'),
                    },
                ],
            },
        ],
    },
};

/**
 * 按钮的定义 START
 * 方便两个工具栏配置快速复用拼装
 */
const undo = {
    id: ActionType.UNDO,
    tipMsg: i18n.t('撤销(Cmd+Z)'),
    icon: TOOLBAR_UNDO,
};
const redo = {
    id: ActionType.REDO,
    tipMsg: i18n.t('重做(Cmd+Y)'),
    icon: TOOLBAR_REDO,
};

const brush = {
    id: ActionType.FORMAT_BRUSH,
    tipMsg: i18n.t('格式刷'),
    icon: TOOLBAR_FORMAT,
};

const clear = {
    id: ActionType.CLEAR_FORMAT,
    tipMsg: i18n.t('清除格式'),
    icon: TOOLBAR_CLEARFORMAT,
};

const insert = {
    id: ActionType.INSERT_ALL,
    tipMsg: i18n.t('插入表格/链接等'),
    // title: i18n.t('插入'),
    icon: TOOLBAR_ADDON,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.TEXT_IMAGE,
        data: [
            {
                id: ActionType.INSERT_TEXT,
                icon: TOOLBAR_TEXT,
                content: i18n.t('文本框'),
            },
            {
                id: `${ActionType.INSERT_SHAPE}-parent`,
                icon: TOOLBAR_SHAPE,
                content: i18n.t('形状'),
                children: [{ id: ActionType.INSERT_SHAPE, title: i18n.t('自定义面板') }],
            },
            {
                id: ActionType.INSERT_PICTURE,
                icon: TOOLBAR_PICTURE,
                content: i18n.t('图片'),
            },
            {
                id: `${ActionType.INSERT_FORM}-parent`,
                icon: TOOLBAR_FORM,
                content: i18n.t('表格'),
                children: [{ id: ActionType.INSERT_FORM, title: i18n.t('自定义面板') }],
            },
            {
                id: ActionType.INSERT_WITH_LINK,
                icon: TOOLBAR_LINK,
                content: i18n.t('链接'),
            },
            divider,
            {
                id: ActionType.INSERT_TENCENT_DOC_ID,
                content: i18n.t('腾讯文档'),
                icon: TOOLBAR_INSERT_DOC,
            },
            {
                id: ActionType.UPLOAD_LOCAL_FILE,
                content: i18n.t('本地文件'),
                icon: TOOLBAR_UPLOAD_FILE,
                tooltip: {
                    titleComponent: UploadFileTooltip,
                },
            },
        ],
    },
};

const insertText = {
    id: ActionType.INSERT_TEXT,
    tipMsg: i18n.t('插入文本框'),
    title: i18n.t('文本框'),
    icon: TOOLBAR_TEXT,
};

const insertShape = {
    id: ActionType.INSERT_SHAPE,
    tipMsg: i18n.t('插入形状'),
    title: i18n.t('形状'),
    icon: TOOLBAR_SHAPE,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.SHAPE,
        data: [
            {
                icon: null,
                content: i18n.t('形状'),
            },
            {
                icon: null,
                content: i18n.t('直线'),
            },
            {
                icon: null,
                content: i18n.t('连接线'),
            },
            {
                icon: null,
                content: i18n.t('曲线'),
            },
            {
                icon: null,
                content: i18n.t('箭头'),
            },
        ],
    },
};

const font = {
    id: ActionType.FONT,
    content: i18n.t('字体'),
    value: '',
    tipMsg: i18n.t('字体'),
    icon: null,
    showSelectedValue: true,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.FONT_FAMILY,
        checkSelectedValue: true,
        data: getFontFamilyConfigData(),
    },
};

const fontSize = {
    id: ActionType.FONTSIZE,
    content: i18n.t('字号'),
    value: '',
    tipMsg: i18n.t('字号'),
    icon: null,
    showSelectedValue: true,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.FONT,
        checkSelectedValue: true,
        data: getFontSizeConfigData(),
    },
};

export const fontSizeIncrease = {
    id: ActionType.FONTSIZE_UP,
    tipMsg: i18n.t('字号放大'),
    icon: TOOLBAR_FONT_SIZE_INCREASE,
};

export const fontSizeDecrease = {
    id: ActionType.FONTSIZE_DOWN,
    tipMsg: i18n.t('字号缩小'),
    icon: TOOLBAR_FONT_SIZE_DECREASE,
};

export const bold = {
    id: ActionType.BOLD,
    value: false,
    tipMsg: i18n.t('加粗'),
    icon: TOOLBAR_BOLD,
};

export const italic = {
    id: ActionType.ITALIC,
    value: false,
    tipMsg: i18n.t('斜体'),
    icon: TOOLBAR_ITALIC,
};

export const underline = {
    id: ActionType.UNDERLINE,
    value: false,
    tipMsg: i18n.t('下划线'),
    icon: TOOLBAR_UNDERLINE,
};

export const deleteline = {
    id: ActionType.DELETELINE,
    value: false,
    tipMsg: i18n.t('删除线'),
    icon: TOOLBAR_DELETELINE,
};

export const subscript = {
    id: ActionType.SUBSCRIPT,
    value: false,
    tipMsg: i18n.t('下标'),
    icon: TOOLBAR_SUBSCRIPT,
};

export const superscript = {
    id: ActionType.SUPERSCRIPT,
    value: false,
    tipMsg: i18n.t('上标'),
    icon: TOOLBAR_SUPERSCRIPT,
};

export const backColor = {
    id: ActionType.BACKCOLOR,
    value: '',
    tipMsg: i18n.t('高亮文本'),
    icon: TOOLBAR_BACKCOLOR,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.COLOR,
    },
};

export const foreColor = {
    id: ActionType.FORECOLOR,
    value: '',
    tipMsg: i18n.t('字体颜色'),
    icon: TOOLBAR_FORECOLOR,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.COLOR,
    },
};

export const itemNumber = {
    id: ActionType.ITEMNUMBER,
    tipMsg: i18n.t('项目符号'),
    icon: TOOLBAR_ITEMNUMBER,
    value: ItemSymbolType.ITEMSYMBOL_NONE,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 4,
        data: getItemSymbolData(),
    },
};

export const digitNumber = {
    id: ActionType.DIGITNUMBER,
    tipMsg: i18n.t('数字编号'),
    icon: TOOLBAR_DIGITNUMBER,
    value: ItemSymbolType.ITEMSYMBOL_NONE,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 3,
        data: getDigitalNumeberData(),
    },
};

const increaseIndent = {
    id: IndentType.INDENT_INCREASE,
    icon: INDENT_INCREASE_ICON,
    tipMsg: i18n.t('增加缩进'),
    tipPlacement: 'right',
    value: IndentType.INDENT_INCREASE,
};

const reduceIndent = {
    id: IndentType.INDENT_REDUCE,
    icon: INDENT_REDUCE_ICON,
    tipMsg: i18n.t('减少缩进'),
    tipPlacement: 'right',
    value: IndentType.INDENT_REDUCE,
};

export const horizontalLeft = {
    id: AlignType.HORIZONTAL_LEFT,
    icon: TOOLBAR_H_ALIGN_LEFT,
    tipMsg: i18n.t('左对齐'),
    tipPlacement: 'right',
    value: AlignType.HORIZONTAL_LEFT,
};

export const horizontalCenter = {
    id: AlignType.HORIZONTAL_CENTER,
    icon: TOOLBAR_H_ALIGN_CENTER,
    tipMsg: i18n.t('居中对齐'),
    tipPlacement: 'right',
    value: AlignType.HORIZONTAL_CENTER,
};

export const horizontalRight = {
    id: AlignType.HORIZONTAL_RIGHT,
    icon: TOOLBAR_H_ALIGN_RIGHT,
    tipMsg: i18n.t('右对齐'),
    tipPlacement: 'right',
    value: AlignType.HORIZONTAL_RIGHT,
};

export const horizontalJustify = {
    id: AlignType.HORIZONTAL_JUSTIFY,
    icon: TOOLBAR_H_ALIGN_JUSTIFY,
    tipMsg: i18n.t('两端对齐'),
    tipPlacement: 'right',
    value: AlignType.HORIZONTAL_JUSTIFY,
};

export const horizontalDistribute = {
    id: AlignType.HORIZONTAL_DISTRIBUTE,
    icon: TOOLBAR_H_ALIGN_DISTRIBUTE,
    tipMsg: i18n.t('分散对齐'),
    tipPlacement: 'right',
    value: AlignType.HORIZONTAL_DISTRIBUTE,
};

export const verticalTop = {
    id: AlignType.VERTICAL_TOP,
    icon: TOOLBAR_V_ALIGN_TOP,
    tipMsg: i18n.t('顶端对齐'),
    tipPlacement: 'right',
};

export const verticalCenter = {
    id: AlignType.VERTICAL_CENTER,
    icon: TOOLBAR_V_ALIGN_CENTER,
    tipMsg: i18n.t('居中对齐'),
    tipPlacement: 'right',
};

export const verticalBottom = {
    id: AlignType.VERTICAL_BOTTOM,
    icon: TOOLBAR_V_ALIGN_BOTTOM,
    tipMsg: i18n.t('底端对齐'),
    tipPlacement: 'right',
};

export const horizontalAlign = {
    id: ActionType.HORIZONTAL_ALIGN,
    tipMsg: i18n.t('水平对齐'),
    icon: TOOLBAR_H_ALIGN_LEFT,
    showSelectedValue: true,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 1,
        data: [
            horizontalLeft,
            horizontalCenter,
            horizontalRight,
            horizontalJustify,
            horizontalDistribute,
        ],
    },
};
const indentation = {
    id: ActionType.INDENT,
    tipMsg: i18n.t('缩进'),
    icon: INDENT_INCREASE_ICON,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        columns: 1,
        data: [
            increaseIndent,
            reduceIndent,
        ],
    },
};
export const rowSpace = {
    id: ActionType.ROW_SPACE,
    tipMsg: i18n.t('行间距'),
    icon: TOOLBAR_ROWSPACING,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.CUSTOM,
        checkSelectedValue: true,
        data: [
            {
                id: 1,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('1倍行距'),
            },
            {
                id: 1.3,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('1.3倍行距'),
            },
            {
                id: 1.5,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('1.5倍行距'),
            },
            {
                id: 2,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('2倍行距'),
            },
            {
                id: 2.5,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('2.5倍行距'),
            },
            {
                id: 3,
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('3倍行距'),
            },
            {
                id: 'custom',
                icon: TOOLBAR_ROWSPACING,
                content: i18n.t('自定义行间距'),
            },
        ],
    },
};
export const verticalAlign = {
    id: ActionType.VERTICAL_ALIGN,
    tipMsg: i18n.t('垂直对齐'),
    icon: TOOLBAR_V_ALIGN_TOP,
    showSelectedValue: true,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 1,
        data: [
            verticalTop,
            verticalCenter,
            verticalBottom,
        ],
    },
};

export const arrange = {
    id: ActionType.MOVE_ITEM,
    tipMsg: i18n.t('排列'),
    icon: TOOLBAR_ARRANGE,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.TEXT_IMAGE,
        data: [
            MOVE_UP_CONFIG,
            {
                id: ActionType.MOVETOP,
                icon: TOOLBAR_MOVETOP,
                content: i18n.t('置顶'),
                tipPlacement: 'right',
            },
            MOVE_DOWN_CONFIG,
            {
                id: ActionType.MOVEBOTTOM,
                icon: TOOLBAR_MOVEBOTTOM,
                content: i18n.t('置底'),
                tipPlacement: 'right',
            },
            SELECT_WINDOW_CONFIG,
            {
                id: ChildActionType.ALIGN,
                content: i18n.t('对齐'),
                icon: ELEMENT_H_ALIGN_LEFT,
                tipPlacement: 'right',
                showSelectedValue: true,
                children: [
                    {
                        id: ActionType.ALIGN_HORIZONTALLT_LEFT,
                        icon: ELEMENT_H_ALIGN_LEFT,
                        content: i18n.t('左对齐'),
                    },
                    {
                        id: ActionType.ALIGN_HORIZONTALLT_CENTER,
                        icon: ELEMENT_H_ALIGN_CENTER,
                        content: i18n.t('居中'),
                    },
                    {
                        id: ActionType.ALIGN_HORIZONTALLT_RIGHT,
                        icon: ELEMENT_H_ALIGN_RIGHT,
                        content: i18n.t('右对齐'),
                    },
                    {
                        id: ActionType.DIVIDER,
                    },
                    {
                        id: ActionType.ALIGN_VERTICALLY_TOP,
                        icon: ELEMENT_V_ALIGN_TOP,
                        content: i18n.t('顶部对齐'),
                    },
                    {
                        id: ActionType.ALIGN_VERTICALLY_CENTER,
                        icon: ELEMENT_H_ALIGN_VCENTER,
                        content: i18n.t('垂直居中'),
                    },
                    {
                        id: ActionType.ALIGN_VERTICALLY_BOTTOM,
                        icon: ELEMENT_V_ALIGN_BOTTOM,
                        content: i18n.t('底部对齐'),
                    },
                    {
                        id: ActionType.DIVIDER,
                    },
                    {
                        id: ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT,
                        icon: ELEMENT_H_ALIGN_DIS,
                        content: i18n.t('横向分布'),
                    },
                    {
                        id: ActionType.ALIGN_DISTRIBUTE_VERTICALLY,
                        icon: ELEMENT_V_ALIGN_DIS,
                        content: i18n.t('纵向分布'),
                    },

                ],

            },
        ],
    },
};

export const group = {
    id: ActionType.GROUP,
    tipMsg: i18n.t('组合'),
    title: i18n.t('组合'),
    icon: TOOLBAR_ADDGROUP,
    showSelectedValue: false,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.CUSTOM,
        checkSelectedValue: false,
        data: [
            {
                id: ActionType.ADDGROUP,
                imgSrc: TOOLBAR_ADDGROUP,
                content: i18n.t('组合'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.REMOVEGROUP,
                imgSrc: TOOLBAR_REMOVEGROUP,
                content: i18n.t('取消组合'),
                tipPlacement: 'right',
            },
        ],
    },
};

export const effect = {
    id: ActionType.EFFECT,
    tipMsg: i18n.t('效果设置'),
    title: i18n.t('效果'),
    icon: TOOLBAR_EFFECT,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.EFFECT,
        data: effectDropdownData,
    },
};

export const fillColor = {
    id: ActionType.FILLCOLOR,
    tipMsg: i18n.t('填充颜色'),
    title: i18n.t('填充颜色'),
    icon: TOOLBAR_FILLCOLOR,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.COLOR,
    },
};

export const borderColor = {
    id: ActionType.BORDERCOLOR,
    tipMsg: i18n.t('边框设置'),
    title: i18n.t('边框设置'),
    icon: TOOLBAR_BORDER,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.COLOR,
    },
};

export const animation = {
    id: ActionType.INSERT_ANIMATION,
    tipMsg: i18n.t('动画'),
    icon: TOOLBAR_ANIM,
    title: i18n.t('动画'),
};


export const pageSetting: ToolListType = {
    id: ActionType.PAGE_SETTING,
    content: i18n.t('页面'),
    tipMsg: i18n.t('页面设置'),
    icon: TOOLBAR_PAGE_SEETING_ICON,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.TEXT_IMAGE,
        data: [
            {
                id: ActionType.CHANGE_BG,
                content: i18n.t('设置背景'),
                icon: TOOLBAR_SLIDEBACKGROUND,
            },
            {
                id: ActionType.SLIDE_SIZE,
                content: i18n.t('幻灯片比例'),
                icon: TOOLBAR_SLIDESIZE_CUSTOM,
                showSelectedValue: true,
                children: [
                    {
                        id: ActionType.SLIDE_STANDARD,
                        icon: TOOLBAR_SLIDESIZE_STANDARD,
                        content: i18n.t('标准（4：3）'),
                    },
                    {
                        id: ActionType.SLIDE_WIDE,
                        icon: TOOLBAR_SLIDESIZE_WIDE,
                        content: i18n.t('宽屏（16：9）'),
                    },
                ],
            },
        ],
    },
};

export const quickTool = {
    id: ActionType.QUICK_TOOL,
    tipMsg: i18n.t('快捷美化'),
    icon: TOOLBAR_QUICK_TOOL_ICON,
    dropdown: {
        type: DropdownType.FONT,
        data: [
            {
                id: ActionType.CHANGE_THEME,
                content: i18n.t('一键换色'),
            },
            {
                id: ActionType.UNIFORM_FONT,
                content: i18n.t('统一字体'),
            },
            // {
            //     id: ActionType.REPLACE_FONT,
            //     content: i18n.t('替换字体'),
            // },
            divider,
            {
                id: ActionType.MUTI_PICTURE_SIZE_SETTING,
                content: i18n.t('批量设置图片尺寸'),
            },
            {
                id: ActionType.MUTI_PICTURE_POS_SETTING,
                content: i18n.t('批量图片布局'),
            },
            {
                id: ActionType.MUTI_PICTURE_EXPORT,
                content: i18n.t('批量图片下载'),
            },
            {
                id: ActionType.DIGITAL_CONTENT_DESENSITIZATION,
                content: i18n.t('数字内容脱敏'),
            },
        ],
    },
};

/**
 * 按钮的定义 END
 */

// 通用功能
export const commonGroup: ToolListType[] = [
    undo,
    redo,
    brush,
    clear,
];

/**
 * 简约工具栏 - 插入模块
 */
export const insertGroup: any = [
    divider,
    insert,
    insertText,
    insertShape,
    /**
     * 插入表格的旧配置先保留作为参考，无问题后删除注释代码
     */
    // {
    //     id: ActionType.INSERT_FORM,
    //     tipMsg: i18n.t('插入表格'),
    //     icon: TOOLBAR_FORM,
    //     dropdown: {
    //         icon: TOOLBAR_DROPDOWN,
    //         type: DropdownType.INSERTTABLE,
    //         columns: 10,
    //         data: [null],
    //     },
    // },
];

/**
 * 字体模块中需要优先被收折的按钮，按照index顺序依次收折
 */
export const fontCollapsePriority = [
    { id: ActionType.DELETELINE },
    { id: ActionType.BACKCOLOR },
    { id: ActionType.UNDERLINE },
    { id: ActionType.ITALIC },
];

/**
 * 字体的更多按钮要插入的位置，插入在这个ID按钮之后
 */
export const fontCollapseMoreItemIndexID = ActionType.FORECOLOR;

/**
 * 简约工具栏 - 字体模块
 */
export const fontGroup = [
    divider,
    font,
    fontSize,
    fontSizeIncrease,
    fontSizeDecrease,
    bold,
    italic,
    underline,
    deleteline,
    subscript,
    superscript,
    backColor,
    foreColor,
];

/**
 * 简约工具栏 - 段落模块
 */
export const paragraphGroup = [
    divider,
    itemNumber,
    digitNumber,
    horizontalAlign,
    indentation,
    rowSpace,
    verticalAlign,
];

/**
 * 简约工具栏 - 效果模块
 */
export const effectGroup: ToolListType[] = [
    divider,
    arrange,
    group,
    effect,
    fillColor,
    borderColor,
];

/**
 * 其他功能区，在工具栏的最右侧
 */
export const otherGroup = [
    divider,
    pageSetting,
    // 当前使用开关 + addon 接口数据动态开启入口
    // intelligentTool,
];

// 选中文本
export const selectTextGroup: ToolListType[] = [
    divider,
    {
        id: ActionType.FONT,
        content: i18n.t('字体'),
        value: '',
        tipMsg: i18n.t('字体'),
        icon: null,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.FONT_FAMILY,
            checkSelectedValue: true,
            data: getFontFamilyConfigData(),
        },
    },
    {
        id: ActionType.FONTSIZE,
        content: i18n.t('字号'),
        value: '',
        tipMsg: i18n.t('字号'),
        icon: null,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.FONT,
            checkSelectedValue: true,
            data: getFontSizeConfigData(),
        },
    },
    divider,
    {
        id: ActionType.BOLD,
        value: false,
        tipMsg: i18n.t('加粗'),
        icon: TOOLBAR_BOLD,
    },
    {
        id: ActionType.ITALIC,
        value: false,
        tipMsg: i18n.t('斜体'),
        icon: TOOLBAR_ITALIC,
    },
    {
        id: ActionType.UNDERLINE,
        value: false,
        tipMsg: i18n.t('下划线'),
        icon: TOOLBAR_UNDERLINE,
    },
    {
        id: ActionType.DELETELINE,
        value: false,
        tipMsg: i18n.t('删除线'),
        icon: TOOLBAR_DELETELINE,
    },
    {
        id: ActionType.SUBSCRIPT,
        value: false,
        tipMsg: i18n.t('下标'),
        icon: TOOLBAR_SUBSCRIPT,
    },
    {
        id: ActionType.SUPERSCRIPT,
        value: false,
        tipMsg: i18n.t('上标'),
        icon: TOOLBAR_SUPERSCRIPT,
    },
    {
        id: ActionType.FORECOLOR,
        value: '',
        tipMsg: i18n.t('字体颜色'),
        icon: TOOLBAR_FORECOLOR,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    {
        id: ActionType.BACKCOLOR,
        value: '',
        tipMsg: i18n.t('高亮文本'),
        icon: TOOLBAR_BACKCOLOR,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    divider,
    {
        id: ActionType.HORIZONTAL_ALIGN,
        tipMsg: i18n.t('水平对齐'),
        icon: TOOLBAR_H_ALIGN_LEFT,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 1,
            data: [
                {
                    id: AlignType.HORIZONTAL_LEFT,
                    icon: TOOLBAR_H_ALIGN_LEFT,
                    tipMsg: i18n.t('左对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_CENTER,
                    icon: TOOLBAR_H_ALIGN_CENTER,
                    tipMsg: i18n.t('居中对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_RIGHT,
                    icon: TOOLBAR_H_ALIGN_RIGHT,
                    tipMsg: i18n.t('右对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_JUSTIFY,
                    icon: TOOLBAR_H_ALIGN_JUSTIFY,
                    tipMsg: i18n.t('两端对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_DISTRIBUTE,
                    icon: TOOLBAR_H_ALIGN_DISTRIBUTE,
                    tipMsg: i18n.t('分散对齐'),
                    tipPlacement: 'right',
                },
            ],
        },
    },
    {
        id: ActionType.VERTICAL_ALIGN,
        tipMsg: i18n.t('垂直对齐'),
        icon: TOOLBAR_V_ALIGN_TOP,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 1,
            data: [
                {
                    id: AlignType.VERTICAL_TOP,
                    icon: TOOLBAR_V_ALIGN_TOP,
                    tipMsg: i18n.t('顶端对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.VERTICAL_CENTER,
                    icon: TOOLBAR_V_ALIGN_CENTER,
                    tipMsg: i18n.t('居中对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.VERTICAL_BOTTOM,
                    icon: TOOLBAR_V_ALIGN_BOTTOM,
                    tipMsg: i18n.t('底端对齐'),
                    tipPlacement: 'right',
                },
            ],
        },
    },
    {
        id: ActionType.ITEMNUMBER,
        tipMsg: i18n.t('项目符号'),
        icon: TOOLBAR_ITEMNUMBER,
        value: ItemSymbolType.ITEMSYMBOL_NONE,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 4,
            data: getItemSymbolData(),
        },
    },
    {
        id: ActionType.DIGITNUMBER,
        tipMsg: i18n.t('数字编号'),
        icon: TOOLBAR_DIGITNUMBER,
        value: ItemSymbolType.ITEMSYMBOL_NONE,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 3,
            data: getDigitalNumeberData(),
        },
    },
    {
        id: ActionType.ROW_SPACE,
        tipMsg: i18n.t('行间距'),
        icon: TOOLBAR_ROWSPACING,
        // value: 1,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.CUSTOM,
            checkSelectedValue: true,
            data: [
                {
                    id: 1,
                    icon: TOOLBAR_ROWSPACING,
                    content: i18n.t('1倍行距'),
                },
                {
                    id: 1.3,
                    icon: TOOLBAR_ROWSPACING,
                    content: i18n.t('1.3倍行距'),
                },
                {
                    id: 1.5,
                    icon: TOOLBAR_ROWSPACING,
                    content: i18n.t('1.5倍行距'),
                },
                {
                    id: 2,
                    icon: TOOLBAR_ROWSPACING,
                    content: i18n.t('2倍行距'),
                },
                {
                    id: 2.5,
                    icon: TOOLBAR_ROWSPACING,
                    content: i18n.t('2.5倍行距'),
                },
                {
                    id: 3,
                    icon: TOOLBAR_ROWSPACING,
                    content: i18n.t('3倍行距'),
                },
                {
                    id: 'custom',
                    icon: TOOLBAR_ROWSPACING,
                    content: i18n.t('自定义行间距'),
                },
            ],
        },
    },
    divider,
    {
        id: ActionType.FILLCOLOR,
        tipMsg: i18n.t('填充颜色'),
        title: i18n.t('填充颜色'),
        icon: TOOLBAR_FILLCOLOR,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    {
        id: ActionType.BORDERCOLOR,
        tipMsg: i18n.t('边框设置'),
        title: i18n.t('边框设置'),
        icon: TOOLBAR_BORDER,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    {
        id: ActionType.EFFECT,
        tipMsg: i18n.t('效果设置'),
        icon: TOOLBAR_EFFECT,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.EFFECT,
            data: effectDropdownData,
        },
    },
    {
        id: ActionType.AI_WRITE,
        tipMsg: i18n.t('AI写作'),
        title: i18n.t('AI写作'),
        icon: TOOLBAR_AI_WRITTING,
        // @ts-ignore
        titleContent: i18n.t('AI写作'),
    },
];

// 图片
export const selectPictureGroup: ToolListType[] = [
    divider,
    {
        id: ActionType.TAILOR_PIC,
        tipMsg: i18n.t('裁剪'),
        title: i18n.t('裁剪'),
        icon: TOOLBAR_CLIP,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.CROP,
            data: [{}],
        },
    },
    {
        id: ActionType.TRANSPARENCY,
        tipMsg: i18n.t('图片透明度'),
        title: i18n.t('图片透明度'),
        icon: TOOLBAR_IMAGE_TRANS,
    },
];

// 表格
export const selectTableGroup = [
    divider,
    {
        id: ActionType.BORDERSTYLE,
        tipMsg: i18n.t('边框格式'),
        title: i18n.t('边框格式'),
        icon: TOOLBAR_BOX,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 5,
            data: getBorderStyleData(),
        },
    },
    {
        id: ActionType.MERGE_CELL,
        value: false,
        tipMsg: i18n.t('合并单元格'),
        title: i18n.t('合并单元格'),
        icon: TOOLBAR_MERGECELL,
    },
];

export const alignItems = {
    id: ChildActionType.ALIGN,
    tipMsg: i18n.t('对齐'),
    icon: ELEMENT_H_ALIGN_LEFT,
    showSelectedValue: false,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.CUSTOM,
        checkSelectedValue: false,
        data: [
            {
                id: ActionType.MOVEUP,
                imgSrc: TOOLBAR_MOVEUP,
                content: i18n.t('上移一层'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.MOVETOP,
                imgSrc: TOOLBAR_MOVETOP,
                content: i18n.t('置顶'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.MOVEDOWN,
                imgSrc: TOOLBAR_MOVEDOWN,
                content: i18n.t('下移一层'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.MOVEBOTTOM,
                imgSrc: TOOLBAR_MOVEBOTTOM,
                content: i18n.t('置底'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.DIVIDER,
            },
            {
                id: ActionType.ALIGN_HORIZONTALLT_LEFT,
                imgSrc: ELEMENT_H_ALIGN_LEFT,
                content: i18n.t('左对齐'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.ALIGN_HORIZONTALLT_CENTER,
                imgSrc: ELEMENT_H_ALIGN_CENTER,
                content: i18n.t('居中'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.ALIGN_HORIZONTALLT_RIGHT,
                imgSrc: ELEMENT_H_ALIGN_RIGHT,
                content: i18n.t('右对齐'),
                tipPlacement: 'right',
            },
            divider,
            {
                id: ActionType.ALIGN_VERTICALLY_TOP,
                imgSrc: ELEMENT_V_ALIGN_TOP,
                content: i18n.t('顶部对齐'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.ALIGN_VERTICALLY_CENTER,
                imgSrc: ELEMENT_H_ALIGN_VCENTER,
                content: i18n.t('垂直居中'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.ALIGN_VERTICALLY_BOTTOM,
                imgSrc: ELEMENT_V_ALIGN_BOTTOM,
                content: i18n.t('底部对齐'),
                tipPlacement: 'right',
            },
            divider,
            {
                id: ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT,
                imgSrc: ELEMENT_H_ALIGN_DIS,
                content: i18n.t('横向分布'),
                tipPlacement: 'right',
            },
            {
                id: ActionType.ALIGN_DISTRIBUTE_VERTICALLY,
                imgSrc: ELEMENT_V_ALIGN_DIS,
                content: i18n.t('纵向分布'),
                tipPlacement: 'right',
            },
        ],
    },
};


// 多选
export const multiSelectGroup = [
    divider,
    {
        id: ActionType.MOVE_ITEM,
        tipMsg: i18n.t('层级排序'),
        icon: TOOLBAR_MOVEUP,
        showSelectedValue: false,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.CUSTOM,
            checkSelectedValue: false,
            data: [
                {
                    id: ActionType.MOVEUP,
                    imgSrc: TOOLBAR_MOVEUP,
                    content: i18n.t('上移一层'),
                    tipPlacement: 'right',
                },
                {
                    id: ActionType.MOVETOP,
                    imgSrc: TOOLBAR_MOVETOP,
                    content: i18n.t('置顶'),
                    tipPlacement: 'right',
                },
                {
                    id: ActionType.MOVEDOWN,
                    imgSrc: TOOLBAR_MOVEDOWN,
                    content: i18n.t('下移一层'),
                    tipPlacement: 'right',
                },
                {
                    id: ActionType.MOVEBOTTOM,
                    imgSrc: TOOLBAR_MOVEBOTTOM,
                    content: i18n.t('置底'),
                    tipPlacement: 'right',
                },
                {
                    id: ActionType.SELECT_WINDOW,
                    imgSrc: TOOLBAR_SELECT_WINDOW,
                    content: i18n.t('全部图层'),
                    tipPlacement: 'right',
                },
            ],
        },
    },
    {
        id: ActionType.GROUP,
        tipMsg: i18n.t('组合'),
        title: i18n.t('组合'),
        icon: TOOLBAR_ADDGROUP,
        showSelectedValue: false,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.CUSTOM,
            checkSelectedValue: false,
            data: [
                {
                    id: ActionType.ADDGROUP,
                    imgSrc: TOOLBAR_ADDGROUP,
                    content: i18n.t('组合'),
                    tipPlacement: 'right',
                },
                {
                    id: ActionType.REMOVEGROUP,
                    imgSrc: TOOLBAR_REMOVEGROUP,
                    content: i18n.t('取消组合'),
                    tipPlacement: 'right',
                },
            ],
        },
    },
    alignItems,
    divider,
    {
        id: ActionType.FONT,
        content: i18n.t('字体'),
        value: '',
        tipMsg: i18n.t('字体'),
        icon: null,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.FONT_FAMILY,
            checkSelectedValue: true,
            data: getFontFamilyConfigData(),
        },
    },
    {
        id: ActionType.FONTSIZE,
        content: i18n.t('字号'),
        value: '',
        tipMsg: i18n.t('字号'),
        icon: null,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.FONT,
            checkSelectedValue: true,
            data: getFontSizeConfigData(),
        },
    },
    divider,
    {
        id: ActionType.BOLD,
        value: false,
        tipMsg: i18n.t('加粗'),
        icon: TOOLBAR_BOLD,
    },
    {
        id: ActionType.ITALIC,
        value: false,
        tipMsg: i18n.t('斜体'),
        icon: TOOLBAR_ITALIC,
    },
    {
        id: ActionType.UNDERLINE,
        value: false,
        tipMsg: i18n.t('下划线'),
        icon: TOOLBAR_UNDERLINE,
    },
    {
        id: ActionType.DELETELINE,
        value: false,
        tipMsg: i18n.t('删除线'),
        icon: TOOLBAR_DELETELINE,
    },
    {
        id: ActionType.SUBSCRIPT,
        value: false,
        tipMsg: i18n.t('下标'),
        icon: TOOLBAR_SUBSCRIPT,
    },
    {
        id: ActionType.SUPERSCRIPT,
        value: false,
        tipMsg: i18n.t('上标'),
        icon: TOOLBAR_SUPERSCRIPT,
    },
    {
        id: ActionType.FORECOLOR,
        value: '',
        tipMsg: i18n.t('字体颜色'),
        icon: TOOLBAR_FORECOLOR,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    {
        id: ActionType.BACKCOLOR,
        value: '',
        tipMsg: i18n.t('字体背景色'),
        icon: TOOLBAR_BACKCOLOR,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    divider,
    {
        id: ActionType.HORIZONTAL_ALIGN,
        // value: AlignType.HORIZONTAL_LEFT,
        tipMsg: i18n.t('水平对齐'),
        icon: TOOLBAR_H_ALIGN_LEFT,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 1,
            data: [
                {
                    id: AlignType.HORIZONTAL_LEFT,
                    icon: TOOLBAR_H_ALIGN_LEFT,
                    tipMsg: i18n.t('左对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_CENTER,
                    icon: TOOLBAR_H_ALIGN_CENTER,
                    tipMsg: i18n.t('居中对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_RIGHT,
                    icon: TOOLBAR_H_ALIGN_RIGHT,
                    tipMsg: i18n.t('右对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_JUSTIFY,
                    icon: TOOLBAR_H_ALIGN_JUSTIFY,
                    tipMsg: i18n.t('两端对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.HORIZONTAL_DISTRIBUTE,
                    icon: TOOLBAR_H_ALIGN_DISTRIBUTE,
                    tipMsg: i18n.t('分散对齐'),
                    tipPlacement: 'right',
                },
            ],
        },
    },
    {
        id: ActionType.VERTICAL_ALIGN,
        // value: AlignType.VERTICAL_TOP,
        tipMsg: i18n.t('垂直对齐'),
        icon: TOOLBAR_V_ALIGN_TOP,
        showSelectedValue: true,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 1,
            data: [
                {
                    id: AlignType.VERTICAL_TOP,
                    icon: TOOLBAR_V_ALIGN_TOP,
                    tipMsg: i18n.t('顶端对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.VERTICAL_CENTER,
                    icon: TOOLBAR_V_ALIGN_CENTER,
                    tipMsg: i18n.t('居中对齐'),
                    tipPlacement: 'right',
                },
                {
                    id: AlignType.VERTICAL_BOTTOM,
                    icon: TOOLBAR_V_ALIGN_BOTTOM,
                    tipMsg: i18n.t('底端对齐'),
                },
            ],
        },
    },
    {
        id: ActionType.ITEMNUMBER,
        tipMsg: i18n.t('项目符号'),
        icon: TOOLBAR_ITEMNUMBER,
        value: ItemSymbolType.ITEMSYMBOL_NONE,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 4,
            data: getItemSymbolData(),
        },
    },
    {
        id: ActionType.DIGITNUMBER,
        tipMsg: i18n.t('数字编号'),
        icon: TOOLBAR_DIGITNUMBER,
        value: ItemSymbolType.ITEMSYMBOL_NONE,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.GRID,
            checkSelectedValue: true,
            columns: 3,
            data: getDigitalNumeberData(),
        },
    },
    divider,
    {
        id: ActionType.FILLCOLOR,
        tipMsg: i18n.t('填充颜色'),
        title: i18n.t('填充颜色'),
        icon: TOOLBAR_FILLCOLOR,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    {
        id: ActionType.BORDERCOLOR,
        tipMsg: i18n.t('边框设置'),
        title: i18n.t('边框设置'),
        icon: TOOLBAR_BORDER,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
    {
        id: ActionType.EFFECT,
        tipMsg: i18n.t('效果设置'),
        icon: TOOLBAR_EFFECT,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.EFFECT,
            data: effectDropdownData,
        },
    },
];

// 连接线
export const selectConnector = [
    divider,
    {
        id: ActionType.BORDERCOLOR,
        tipMsg: i18n.t('边框设置'),
        icon: TOOLBAR_BORDER,
        dropdown: {
            icon: TOOLBAR_DROPDOWN,
            type: DropdownType.COLOR,
        },
    },
];

// 当有选中元素时
export const selected = [
    divider,
    alignItems,
];

// 其他功能区（固定）
export const animationGroup = [
    divider,
    animation,
];

// 最右侧的固定区
export const rightSideGroup = [
    {
        id: ActionType.SEARCH_REPLACE,
        content: i18n.t('查找'),
        tipMsg: i18n.t('查找和替换'),
        icon: TOOLBAR_SEARCH_REPLACE,
    },
];

// 其他功能区（固定）
export const moreItem = {
    id: ActionType.MORE,
    content: i18n.t('更多'),
    tipMsg: i18n.t('更多'),
    icon: TOOLBAR_LISTMORE,
    dropdown: {
        type: DropdownType.TOOLBAR,
        data: [],
    },
};

// 字体功能区的更多按钮，窗口过窄的时候会增加该按钮
export const moreFontItem = {
    id: ActionType.MORE_FONT,
    tipMsg: i18n.t('更多'),
    icon: TOOLBAR_LISTMORE,
    dropdown: {
        type: DropdownType.INNER_TOOLBAR,
        data: [],
    },
};


export const SelectElementTypes = {
    SHAPE: 'Shape', // 图形、文本
    PICTURE: 'Picture', // 图片
    TABLE: 'Table', // 表格
    CHART: 'Chart', // 图表
    CONNECTOR: 'Connector', // 连接线
    GROUP: 'Group', //
    MULTIPLE: 'Multiple', // 多选
    TEMPLATE: 'Template',
    NOTE: 'note',
    NONE: 'none', // 未选
};

export const DropdowFrom = {
    DOUBLEITEM: 'doubleItem',
};

// eslint-disable-next-line consistent-return
export function dataWithId(id): ToolListType {
    for (let i = 0; i < selectTextGroup.length; i++) {
        const item = selectTextGroup[i];
        if (item.id === id) {
            return item;
        }
    }
    for (let i = 0; i < multiSelectGroup.length; i++) {
        const item = multiSelectGroup[i];
        if (item.id === id) {
            return item;
        }
    }
    for (let i = 0; i < selectTableGroup.length; i++) {
        const item = selectTableGroup[i];
        if (item.id === id) {
            return item;
        }
    }
    for (let i = 0; i < selectPictureGroup.length; i++) {
        const item = selectPictureGroup[i];
        if (item.id === id) {
            return item;
        }
    }
    return selectTextGroup[0];
}

class ToolbarManager {
    /**
     * 单层工具栏的数据拼装接口
     */
    public static getSimpleGroupListByType(type) {
        let groupList: ToolListType[] = commonGroup.concat(insertGroup);
        // 只有在拥有编辑权限的时候，才添加如下模块
        if (_get(window.clientVars, 'privilegeAttribute.can_edit')) {
            // 添加字体模块
            groupList = groupList.concat(fontGroup);
            // 添加段落模块
            groupList = groupList.concat(paragraphGroup);
            // 添加效果绘图模块
            groupList = groupList.concat(effectGroup);
        }

        if (type === SelectElementTypes.PICTURE || type === SHAPE_IMAGE_FILL || type === SHAPE_IMAGE_TILE_FILL) {
            groupList = groupList.concat(selectPictureGroup);
        } else if (type === SelectElementTypes.TABLE) {
            groupList = groupList.concat(selectTableGroup);
        }

        groupList = groupList.concat(animationGroup);
        groupList = groupList.concat(otherGroup);

        return deepCopy(groupList);
    }

    /**
     * 双层工具栏的数据拼装接口
     * 包含top/bottom属性的，是双层按钮的配置项
     * 包含big属性的，是单层按钮的配置项
     */
    public static getClassicGroupListByType(type) {
        // 双栏按钮需要补充title信息
        const pageSettingBig = Object.assign({}, pageSetting);
        pageSettingBig.title = i18n.t('页面设置');
        const arrangeBig = Object.assign({}, arrange);
        (arrangeBig as any).title = i18n.t('排列');

        const groupList = [
            // common
            {
                top: [undo, redo],
                bottom: [brush, clear],
            },
            divider,
            // insert
            {
                big: [insert, insertText, insertShape],
            },
            divider,
            // font
            {
                top: [font, fontSize, fontSizeIncrease, fontSizeDecrease],
                bottom: [bold, italic, underline, deleteline, backColor, foreColor],
            },
            divider,
            // paragraph
            {
                top: [itemNumber, digitNumber, reduceIndent, increaseIndent, rowSpace],
                bottom: [horizontalLeft, horizontalCenter, horizontalRight, verticalAlign],
            },
            divider,
            // effectLeft
            {
                big: [arrangeBig],
            },
            // effectMiddle
            {
                top: [effect],
                bottom: [group],
            },
            // effectRight
            {
                top: [fillColor],
                bottom: [borderColor],
            },
            // dynamicArr要插入的位置
            divider,
            // animation
            {
                big: [animation],
            },
            divider,
            // quick tool
            {
                big: [quickTool],
            },
            divider,
            // pageSetting
            {
                big: [pageSettingBig],
            },
        ];

        let dynamicArr: ToolListType[] = [];
        // 目前只有图片，形状填充图片和表格有动态按钮变化
        if (type === SelectElementTypes.PICTURE || type === SHAPE_IMAGE_FILL || type === SHAPE_IMAGE_TILE_FILL) {
            const pictureGroup = selectPictureGroup.slice(1);
            dynamicArr = dynamicArr.concat(pictureGroup);
        } else if (type === SelectElementTypes.TABLE) {
            const tableGroup = selectTableGroup.slice(1);
            dynamicArr = dynamicArr.concat(tableGroup);
        }
        if (dynamicArr.length > 0) {
            // dynamicArr 选择元素特有的功能区
            const dynamicObj = [
                divider,
                {
                    big: dynamicArr,
                },
            ];
            groupList.splice(groupList.length - 4, 0, ...dynamicObj);
        }

        if (isIntelligentToolUpdated) {
            const intelligentToolBig = Object.assign({}, intelligentTool);
            intelligentToolBig.title = i18n.t('插件');
            groupList.push(divider, { big: [intelligentToolBig] });
        }

        return deepCopy(groupList);
    }

    public static getGroupListByType(type) {
        if (type === SelectElementTypes.TEMPLATE) {
            return deepCopy(defaultTemplates);
        }
        const toolbarMode = (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .viewableServiceLayer?.toolbarStateManager.getToolbarMode();
        if (toolbarMode === ToolbarType.DOUBLE_TOOLBAR) {
            return ToolbarManager.getClassicGroupListByType(type);
        }
        return ToolbarManager.getSimpleGroupListByType(type);
    }

    public static filterNeighbourDivider(itemArray) {
        // 移除相邻分割线
        let items = itemArray;
        let isLastDiver = false;
        let lastIndex = -10;
        items =  items.filter((item, index) => {
            if (item.id === ActionType.DIVIDER) {
                const oldLastDiver = isLastDiver;
                const isOne = index - lastIndex === 1;
                isLastDiver = true;
                lastIndex = index;
                if (oldLastDiver && isOne) return false;
            }
            return true;
        });
        return items;
    }

    public static getTextGroupList(isIframe, groupList) {
        let textGroupList = groupList;
        if (isIframe) {
            textGroupList = textGroupList.concat(multiSelectGroup.slice(0, 2)).concat(alignItems);
        } else {
            textGroupList = textGroupList.concat(selected).concat(selectTextGroup)
                .concat();
        }
        return textGroupList;
    }

    public static showThirdParty() {
        return !config.supportEnterprise(EnterPriseType.ALL);
    }

    public static getPicGroupList(isMedia, groupList) {
        let picGroupList = groupList;
        if (isMedia) {
            picGroupList = picGroupList.concat(multiSelectGroup.slice(0, 2)).concat(alignItems);
        } else {
            picGroupList = picGroupList.concat(selected).concat(selectPictureGroup)
                .concat();
        }
        return picGroupList;
    }

    public static updateAddonList(addonList) {
        if (!addonList.config) {
            return;
        }
        const showThirdPartyEntry = ToolbarManager.showThirdParty();
        const addonItem = insertGroup.find(item => item.id === ActionType.INSERT_ALL);
        if (addonItem?.dropdown?.data?.find(item => item.id === ActionType.INSERT_IFRAME)) {
            return;
        }
        const menuCate = {
            [addonList.config.menus[0].category]: 1,
        };
        const menuList: ToolListType[] = [];
        addonList.config.menus.forEach((menu) => {
            if (menu.type === DIVIDE) {
                menuList.push({
                    id: ActionType.DIVIDER,
                });
                return;
            }
            if (!menuCate[menu.category]) {
                menuList.push({
                    id: ActionType.DIVIDER,
                });
                menuCate[menu.category] = 1;
            }

            menuList.push({
                id: ActionType.INSERT_IFRAME_ITEM,
                icon: `${addonList.file_path}/${menu.icon}`,
                content: i18n.t(menu.name),
                aid: menu.id,
            });
        });
        if (showThirdPartyEntry) {
            addonItem?.dropdown?.data?.push({
                id: ActionType.INSERT_IFRAME,
                content: i18n.t('第三方内容'),
                icon: TOOLBAR_ADDON_TOOL,
                children: menuList,
            });
        }
    }

    public static updateAddonFormula(addonList) {
        if (!addonList.config) {
            return;
        }

        const insertItem = insertGroup.find(item => item.id === ActionType.INSERT_ALL);
        if (insertItem?.dropdown?.data?.find(item => item.id === ActionType.INSERT_WITH_LATEX)) {
            return;
        }
        const menuCate = {
            [addonList.config.menus[0].category]: 1,
        };
        const menuList: ToolListType[] = [];

        addonList.config.menus.forEach((menu) => {
            if (!menuCate[menu.category]) {
                menuList.push({ id: ActionType.DIVIDER });
                menuCate[menu.category] = 1;
            }

            menuList.push({
                id: ActionType.INSERT_WITH_LATEX,
                icon: TOOLBAR_LATEX,
                content: i18n.t(menu.name),
                aid: menu.id,
                toggle: true,
            });
        });

        insertItem?.dropdown?.data?.splice(
            // 将 Latex 插在链接后面
            insert.dropdown.data.findIndex(({ id }) => id === ActionType.INSERT_WITH_LINK) + 1,
            0,
            ...menuList,
        );

        return insertGroup;
    }

    /**
     * 更新非官方插件到 `智能工具` 目录下
     * @param {*} addonPackage
     * @returns void
     */
    public static updateAddonUnOfficial(addonPackage) {
        if (!addonPackage.config) return;
        if (otherGroup.find(item => item.id === ActionType.INTELLIGENT_TOOL)) return;

        // FIXME: Toolbar 存在大量的类似的对象赋值逻辑，当前的流程是：
        // 上层 AddonManeger 触发 ToolbarManager updateXXX -> 重新计算全部 toolbardata -> render
        addonPackage.config.menus.forEach((menu) => {
            // menu.id 形如 `${addonId}_0`
            const addonMaterial = {
                icon: menu.icon,
                // hover 时展示的 tooltip 配置:
                title: menu.name,
                subTitle: menu.subTitle,
                imageUrl: menu.imageUrl,
                description: menu.description,
            };

            intelligentTool?.dropdown?.data?.push({
                id: ActionType.ADDON_UNOFFICIAL,
                aid: menu.id,
                content: addonMaterial.title,
                icon: addonMaterial.icon,
                toggle: true,
                tooltip: {
                    titleComponent: IntelligentToolDescriptionCard,
                    titleProps: addonMaterial,
                    autoAdjustOverflow: true,
                    titleWidth: 230,
                },
            });
        });

        if ((intelligentTool?.dropdown?.data?.length || 0) > 0) {
            isIntelligentToolUpdated = true;
            otherGroup.push(divider, intelligentTool);
        }
    }
}

/** 品类(当前有 world、ppt) 公共入口 <智能工具> */
let isIntelligentToolUpdated = false;
const intelligentTool: ToolListType = {
    id: ActionType.INTELLIGENT_TOOL,
    //  ppt 入口 hover 文案变更 '智能工具' -> '插件'，icon 保持不变
    content: i18n.t('插件'),
    tipMsg: i18n.t('插件'),
    icon: TOOLBAR_PLUGIN,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.TEXT_IMAGE,
        data: [],
    },
};

export default ToolbarManager;
